import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Fade from '@material-ui/core/Fade';
import Slideshow from '../slideshow/Slideshow/Slideshow';
import Loading from '../Loading';
import MediaQuery from 'react-responsive';
import { styles } from '../../styles/chart-panel-styles';

const SlideshowPanel = (props) => {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <MediaQuery query='(min-device-width: 1024px)'>
        <Fade>
          <Slideshow cards={props.cards} />
        </Fade>
      </MediaQuery>
      <MediaQuery query="(max-device-width: 1023px)">
        <Fade in={true} timeout={1500}>
          <Grid container spacing={16} classes={{root: classes.root}}>
            {props.cards}
          </Grid>
        </Fade>
      </MediaQuery>
    </div>
  )
}

SlideshowPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SlideshowPanel);


// WEBPACK FOOTER //
// ./src/components/ChartPanel/SlideshowPanel.js